<template>
  <div class="login">
    <div class="login-box">
      <div class="login-box-left">
        <a href="javascript:;"></a>
      </div>
      <div v-loading="isLoading" class="login-box-right">
        <div>
          <h2>广告投放平台</h2>
          <div>
            <div>
              <input v-model="account" type="text" :class="[accountTip!==''&&'color-error']" placeholder="请输入账号" @input="resetTips($event, 'accountTip')">
              <span>{{accountTip}}</span>
              <i></i>
            </div>
            <div>
              <input v-model="password" type="password" :class="[passwordTip!==''&&'color-error']" placeholder="请输入密码" @input="resetTips($event, 'passwordTip')">
              <span>{{passwordTip}}</span>
              <i></i>
            </div>
            <div class="operate-memory">
              <div @click="memoryFun($event,true)">
                <i class="el-icon-check" :class="{true:isMemoryAccount}"></i>
                <span>记住账号</span>
              </div>
              <div @click="memoryFun($event,false)">
                <i class="el-icon-check" :class="{true:isMemoryPassword}"></i>
                <span>记住密码</span>
              </div>
            </div>
          </div>
          <a href="javascript:;" @click="loginInt">登录</a>
        </div>
        <div class="operate-coryright">
          <p>{{myOption.copyright.text1}}{{new Date().getFullYear()}}{{myOption.copyright.text2}}</p>
          <a href="http://beian.miit.gov.cn/" target="_blank">{{myOption.copyright.text3}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { loginRequest } from '../assets/js/loginRequest'

// 注册组件脚本
export default {
  name: 'Login',
  data () {
    return {
      // 是否显示加载动画
      isLoading: false,
      // 账号
      account: '',
      // 密码
      password: '',
      // 是否记忆账号
      isMemoryAccount: true,
      // 是否记忆密码
      isMemoryPassword: true,
      // 账户错误提示
      accountTip: '',
      // 密码错误提示
      passwordTip: ''
    }
  },
  methods: {
    ...mapActions(['SetTokenAndUser']),
    // 记忆功能
    memoryFun (event, type) {
      if (event) {
        if (type) {
          this.isMemoryAccount = !this.isMemoryAccount
        } else {
          this.isMemoryPassword = !this.isMemoryPassword
        }
      }
    },
    // 登录
    loginInt () {
      const account = this.account.trim()
      const password = this.password.trim()
      if (account === '') {
        this.accountTip = '请输入账号'
        return false
      }
      if (password === '') {
        this.passwordTip = '请输入密码'
        return false
      }
      this.isLoading = true
      // 进行登录请求
      loginRequest(account, password, false).then(res => {
        const code = res.data.code
        if (code === 200) {
          // stire储存token和用户信息
          this.SetTokenAndUser({
            token: res.headers.authorization,
            info: res.data.data
          })
          // 缓存用户习惯
          window.localStorage.setItem(this.myOption.storage.memory, window.btoa(unescape(encodeURIComponent(JSON.stringify({
            account: this.isMemoryAccount ? account : '',
            password: this.isMemoryPassword ? password : '',
            isMemoryAccount: this.isMemoryAccount,
            isMemoryPassword: this.isMemoryPassword
          })))))
          // 路由跳转
          this.$router.push({path: '/home'})
        } else if (code === 1001) {
          this.passwordTip = '账号或密码有误，请重新输入'
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    resetTips (val, type) {
      if (val !== '' && this[type] !== '') {
        this[type] = ''
      }
    }
  },
  created () {
    var _this = this
    // 键盘监听
    document.onkeydown = function (e) {
      if (_this.isLoading) {
        return false
      }
      let key = window.event.keyCode
      if (key === 13) {
        _this.loginInt()
      }
    }
  },
  mounted () {
    // 判断浏览器是否支持Storage
    if (!window.Storage && !window.localStorage && !(window.localStorage instanceof Storage)) {
      alert('您的浏览器不支持 Web Storage ，请将浏览器升级至最新版本或更换浏览器')
      return false
    }
    // 账号记忆体数据信息，先从浏览器获取，获取不到时默认赋值
    const webInfo = window.localStorage.getItem(this.myOption.storage.memory)
    const memoryInfo = webInfo ? JSON.parse(window.atob(webInfo)) : false
    // 账号记忆逻辑
    if (memoryInfo) {
      this.isMemoryAccount = memoryInfo.isMemoryAccount
      if (this.isMemoryAccount) {
        this.account = memoryInfo.account
      }
      this.isMemoryPassword = memoryInfo.isMemoryPassword
      if (this.isMemoryPassword) {
        this.password = memoryInfo.password
      }
    }
  }
}
</script>

<style scoped>
  .login{
    position: relative;
    width: 100%;
    height: 100%;
    background: url("../assets/images/login-background.jpg") center no-repeat;
    background-size: cover;
    font-size: 0;
  }
  .login-box{
    position: absolute;
    top: 46%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1135px;
    height: 548px;
    border-radius: 20px;
    overflow: hidden;
  }
  .login-box>div{
    display: inline-block;
    vertical-align: middle;
  }
  .login-box-left{
    position: relative;
    width: 620px;
    height: 100%;
    background: url("../assets/images/login-box-left.png") center no-repeat;
    background-size: contain;
  }
  .login-box-left>a{
    position: absolute;
    top: 29px;
    left: 32px;
    width: 137px;
    height: 23px;
    background: url("../assets/images/login-logo.png") center no-repeat;
    background-size: contain;
  }
  .login-box-right{
    position: relative;
    width: 515px;
    height: 100%;
    background-color: #fff;
  }
  .login-box-right>div{
    margin: 0 auto;
    width: 318px;
  }
  .login-box-right>div>h2{
    padding-top: 70px;
    font-size: 28px;
    color: #4d69f6;
    letter-spacing: 2px;
    line-height: 1.1;
    text-align: center;
  }
  .login-box-right>div>div{
    margin-top: 47px;
  }
  .login-box-right>div>div>div{
    margin: 0 auto 20px;
    width: 100%;
    position: relative;
  }
  .login-box-right>div>div>div>input{
    padding: 0 0 0 34px;
    width: 100%;
    height: 40px;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
    font-size: 14px;
    color: #666;
    line-height: 1.1;
    outline: none;
  }
  .login-box-right>div>div>div>span{
    position: absolute;
    bottom: -16px;
    left: 0;
    font-size: 12px;
    color: #e43937;
    line-height: 1.1;
  }
  .login-box-right>div>div>div>i{
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 100%;
    background-size: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 14px 16px;
  }
  .login-box-right>div>div>div:nth-child(1)>i{
    background-image: url(../assets/images/login-user.png);
  }
  .login-box-right>div>div>div:nth-child(2)>i{
    background-image: url(../assets/images/login-password.png);
  }
  .login-box-right>div>a:nth-child(3) {
    display: block;
    margin-top: 38px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    background-color: #4d69f6;
    border-radius: 5px;
  }
  /*记忆功能*/
  .operate-memory{
    display: flex;
    justify-content: space-between;
    margin-bottom: 70px;
    user-select: none;
  }
  .operate-memory>div{
    display: inline-flex;
    cursor: pointer
  }
  .operate-memory>div>i{
    margin-right: 8px;
    width: 14px;
    height: 14px;
    font-size: 12px;
    color: #fff;
    border: 1px solid #cacaca;
    border-radius: 3px;
  }
  .operate-memory>div>i.true{
    border-color: #4d69f6;
    background-color: #4d69f6;
  }
  .operate-memory>div>span{
    font-size: 14px;
    line-height: 14px;
    color: #666
  }
  .operate-coryright{
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    font-size: 12px;
    color: #969696;
    white-space: nowrap;
    text-align: center;
  }
  .operate-coryright>a{
    font-size: 12px;
    color: #969696;
  }
  .operate-coryright>a:hover{
    text-decoration: underline;
  }
  .color-error{
    border-color:#F56C6C!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue